import { render, staticRenderFns } from "./WorkFaqList.vue?vue&type=template&id=06fef038&"
import script from "./WorkFaqList.vue?vue&type=script&lang=js&"
export * from "./WorkFaqList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports